import { Plato } from './plato.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { getPositionOfLineAndCharacter } from 'typescript';

@Injectable({
  providedIn: 'root',
})
export class PlatosService {
  constructor(private httpClient: HttpClient) {}

  getDietas(): Observable<any> {
    return this.httpClient.get(environment.apiURL + '/platos/dietas');
  }
  getHorarios(): Observable<any> {
    return this.httpClient.get(environment.apiURL + '/platos/horarios');
  }
  getEstaciones(): Observable<any> {
    return this.httpClient.get(environment.apiURL + '/platos/estaciones');
  }
  getTecnicasCoccion(): Observable<any> {
    return this.httpClient.get(environment.apiURL + '/platos/tecnicas-coccion');
  }
  getTiposAlimento(): Observable<any> {
    return this.httpClient.get(environment.apiURL + '/platos/tipos-alimento');
  }
  getTiposImagenes(): Observable<any> {
    return this.httpClient.get(environment.apiURL + '/platos/tipos-imagenes');
  }

  getPlato(urlSlug: string): Observable<any> {
    return this.httpClient.get(environment.apiURL + '/plato/' + urlSlug);
  }

  getImagenes(id: string): Observable<any> {
    return this.httpClient.get(environment.apiURL + '/plato/imagenes/' + id);
  }
  getPlatos(
    currentPage: number,
    pageSize: number,
    fromDate: string,
    toDate: string,
    keyword: string
  ): Observable<any> {
    const queryParams =
      '?currentpage=' +
      currentPage +
      '&pagesize=' +
      pageSize +
      '&fromdate=' +
      fromDate +
      '&todate=' +
      toDate +
      '&keyword=' +
      keyword.trim();
    return this.httpClient.get(environment.apiURL + '/platos' + queryParams);
  }
  getPlatosLength(
    fromDate: string,
    toDate: string,
    keyword: string
  ): Observable<any> {
    const queryParams =
      '?fromdate=' + fromDate + '&todate=' + toDate + '&keyword=' + keyword;
    return this.httpClient.get(
      environment.apiURL + '/platos/length' + queryParams
    );
  }

  getTecnicasByPlato(platoID: string): Observable<any> {
    return this.httpClient.get(
      environment.apiURL + '/platos/tecnicas/' + platoID
    );
  }

  getPlatoRedes(platoID: string): Observable<any> {
    return this.httpClient.get(environment.apiURL + '/platos/redes/' + platoID);
  }

  getIngredientes(): Observable<any> {
    return this.httpClient.get(environment.apiURL + '/platos/ingredientes');
  }
  getIngredientesByPlato(platoID: string): Observable<any> {
    return this.httpClient.get(
      environment.apiURL + '/platos/ingredientes/' + platoID
    );
  }
  getCondimentos(): Observable<any> {
    return this.httpClient.get(environment.apiURL + '/platos/condimentos');
  }
  getCondimentosByPlato(platoID: string): Observable<any> {
    return this.httpClient.get(
      environment.apiURL + '/platos/condimentos/' + platoID
    );
  }
  getAllPlatos(): Observable<any> {
    return this.httpClient.get(environment.apiURL + '/platos/all');
  }

  newPlato(plato: Plato): Observable<any> {
    console.log('Registrando plato: ', plato);
    /*const platoData = new FormData();
    platoData.append('plato_id', plato.plato_id);
    platoData.append('plato_description', plato.plato_description);
    platoData.append('plato_date', plato.plato_date);
    platoData.append('url_slug', plato.url_slug);
    platoData.append('created_by', plato.created_by);
    platoData.append('modified_by', plato.modified_by);
    platoData.append('parent_id', plato.parent_id);
    platoData.append('horario_id', plato.horario_id);
    platoData.append('custom_horario', plato.custom_horario);
    platoData.append('dieta_id', plato.dieta_id);
    platoData.append('custom_dieta', plato.custom_dieta);
    platoData.append('estacion_id', plato.estacion_id);
    platoData.append('tecnicas', JSON.stringify(plato.tecnicas));
    platoData.append('ingredientes', JSON.stringify(plato.ingredientes));
    platoData.append('condimentos', JSON.stringify(plato.condimentos));*/
    //platoData.append('image', plato.image, plato.url_slug);

    //plato.image = null;

    const platoAux: Plato = Object.assign({}, plato);
    platoAux.images = [
      {
        image_path: null,
        preview: null,
        tipo_id: 1,
        sort_id: 1,
      },
    ];

    return this.httpClient.post(environment.apiURL + '/plato/', platoAux);
  }

  updatePlato(plato: Plato): Observable<any> {
    console.log('Actualizando plato: ', plato);
    /*const platoData = new FormData();
    platoData.append('plato_id', plato.plato_id);
    platoData.append('plato_description', plato.plato_description);
    platoData.append('plato_date', plato.plato_date);
    platoData.append('url_slug', plato.url_slug);
    platoData.append('created_by', plato.created_by);
    platoData.append('modified_by', plato.modified_by);
    platoData.append('parent_id', plato.parent_id);
    platoData.append('horario_id', plato.horario_id);
    platoData.append('custom_horario', plato.custom_horario);
    platoData.append('dieta_id', plato.dieta_id);
    platoData.append('custom_dieta', plato.custom_dieta);
    platoData.append('estacion_id', plato.estacion_id);
    platoData.append('tecnicas', JSON.stringify(plato.tecnicas));
    platoData.append('ingredientes', JSON.stringify(plato.ingredientes));
    platoData.append('condimentos', JSON.stringify(plato.condimentos));*/

    //plato.image = null;

    /*console.log('typeof (plato.image): ', typeof plato.image);
    if (typeof plato.image === 'object') {
      platoData.append('image', plato.image, plato.url_slug);
    } else {
      platoData.append('image', plato.image);
    }*/

    const platoAux: Plato = Object.assign({}, plato);
    platoAux.images = [
      {
        image_path: null,
        preview: null,
        tipo_id: 1,
        sort_id: 1,
      },
    ];

    return this.httpClient.patch(environment.apiURL + '/plato/', platoAux);
  }

  unlinkImages(platoID: string): Observable<any> {
    return this.httpClient.delete(
      environment.apiURL + '/plato/imagenes/unlink/' + platoID
    );
  }

  uploadImage(
    platoID: string,
    image: any,
    urlSlug: string,
    tipoID: string,
    sortID: string
  ): Observable<any> {
    console.log('platoID: ', platoID);
    console.log('image: ', image);
    urlSlug = urlSlug + '-';
    urlSlug = urlSlug + Math.floor(Math.random() * 100000) + 1;
    console.log('urlSlug: ', urlSlug);
    const platoData = new FormData();
    platoData.append('plato_id', platoID);
    platoData.append('tipo_id', tipoID);
    platoData.append('sort_id', sortID);

    if (typeof image === 'object') {
      platoData.append('image', image, urlSlug);
    } else {
      platoData.append('image', image);
    }

    return this.httpClient.post(environment.apiURL + '/plato/image', platoData);
  }
}
